import React from 'react';
import { PressImage } from '../PressImage';

export default function Hit(data) {
  const { hit, additionalData } = data;
  return (
    <PressImage key={hit.id} res={hit} type={additionalData.type ?? 'public'} />
  );
}
